import './Searchbar.css';
import React from 'react';
import { standardizeString } from 'utils/function';
import PropTypes from 'prop-types'
import Icon, { IconList } from './Icon';

const propTypes = {
    placeholder: PropTypes.string,
    onSearch: PropTypes.func
};
const defaultProps = {
    placeholder: '',
    onSearch: (keywords) => {}
};

const Searchbar = (props) => {
    /**** Variables and States ****/
    const [keyword, setKeyword] = React.useState('');
  const [preKeyword, setPreKeyword] = React.useState('');
    /**** Event Handlers ****/
    const onKeyDown = (e) => {
        if(e.key==='Enter' && keyword!==preKeyword) {
            onSearch();
        }
    }
    const onSearch = () => {
        setPreKeyword(keyword);
        let keywords = standardizeString(keyword).replaceAll(/[、､ 　]/g,",");
        keywords = keywords.split(",");
        keywords = keywords.map(keyword=>keyword.trim());
        keywords = keywords.filter(keyword=>keyword!=="");
        props.onSearch(keywords);
    }
    /**** Main Render ****/
    return (
        <label className='searchbar_flex-row searchbar'>
            <div className='searchbar_flex-row main-search'>
                <input 
                    value={keyword} 
                    className='search-input' 
                    placeholder={props.placeholder}
                    onChange={(e) => setKeyword(e.target.value)}
                    onKeyDown={onKeyDown}
                />
                <Icon icon={IconList.iconSearch} containerStyle='icon_container' onClick={onSearch}/>
            </div>
        </label>
    )
}

Searchbar.propTypes = propTypes;
Searchbar.defaultProps = defaultProps;

export default Searchbar;